
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MeverHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section
      ref={ref}
      className="relative h-[70vh] min-h-[560px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/125e90a2279818e3141d04602e492055.jpg"
          alt="MeVER Hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div
        className={`relative z-10 text-center px-8 max-w-5xl mx-auto w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-sm uppercase tracking-[0.3em] text-white/70 mb-6">
          Work & Lifestyle Products
        </p>
        <h1 className="text-7xl lg:text-8xl font-light text-white tracking-wide mb-8">
          MeVER
        </h1>
        <div className="max-w-2xl mx-auto">
          <p className="text-lg text-white/90 leading-relaxed mb-4">
            仕事と暮らしの境界をなめらかにする、ワーク＆ライフスタイルプロダクト。
          </p>
          <p className="text-base text-white/70 leading-relaxed">
            Products that blur the line between work and life, designed for those who create.
          </p>
        </div>
      </div>
    </section>
  );
}
